import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CallService } from 'src/app/core/services/call/call.service';

@Component({
  selector: 'app-call-connected',
  templateUrl: './call-connected.component.html',
  styleUrls: ['./call-connected.component.scss']
})
export class CallConnectedComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CallConnectedComponent>,
    private _callService: CallService,
    public dialog: MatDialog,
  ) { }

  close(val: boolean){
    this.dialogRef.close(val);
  }
}
